import { RootState } from '@/shared/store'
import { createSelector } from '@reduxjs/toolkit'

export const selectBusinessModel = createSelector(
  [state => state],
  (state: RootState) => state.user.businessModel,
)
